import {useEffect, useState} from "react";
import {useMapsLibrary} from "@vis.gl/react-google-maps";

export type UseAutocompleteSuggestionsReturn = {
  suggestions: google.maps.places.AutocompleteSuggestion[];
  isLoading: boolean;
  resetSession: () => void;
};

/**
 * A reusable hook that retrieves the the first search results placeID from Google's Places Text Search API.
 */
export function usePlaceIdSearch(searchText: string) {
  const placesLib = useMapsLibrary("places");
  const [id, setId] = useState("");

  useEffect(() => {
    if (!placesLib) return;
    const {Place} = placesLib;
    Place.searchByText({
      textQuery: searchText,
      fields: ["id"],
    }).then((res) => {
      if (res.places && res.places.length > 0) setId(res.places[0].id);
    });
  }, [placesLib, searchText]);

  return {
    id,
  };
}
